import { useQuery, useQueryClient } from '@tanstack/react-query';

export const logIn = async (returnUrl = null) => {
    
    let loginUrl = `auth/login`;
    const loginUrlQueryParams = new URLSearchParams();
    
    let redirectUrl;
    if (typeof returnUrl === 'string' && returnUrl) {
        redirectUrl = returnUrl;
    } else {
        redirectUrl = window.location.pathname + window.location.search;
    }
    
    console.log('Using redirectUrl:', redirectUrl);
    
    loginUrlQueryParams.set('redirectUrl', redirectUrl);
    loginUrl += `?${loginUrlQueryParams.toString()}`;
    
    console.log('Final login URL:', loginUrl);
    window.location.href = loginUrl;
};

export const logOut = async () => {
    localStorage.clear();
    sessionStorage.clear();
    
    sessionStorage.setItem('justLoggedOut', 'true');
    
    let logoutUrl = 'auth/logout';
    window.location.href = logoutUrl;
}

const fetchUser = async () => {
  const response = await fetch('auth/user', {
    credentials: 'include',
    redirect: 'manual'
  });
  
  if (response.type === 'opaqueredirect') {
    const error = new Error('User not authenticated');
    error.status = 401;
    throw error;
  }
  
  if (!response.ok) {
    const error = new Error('Failed to fetch user');
    error.status = response.status;
    throw error;
  }
  const userData = await response.json();
  console.log('fetchUser success:', userData);
  return userData;
};

export const useUser = () => {
  const queryClient = useQueryClient();

  const { data: user, isLoading, error } = useQuery({
    queryKey: ['user'],
    queryFn: fetchUser,
    staleTime: 5 * 60 * 1000,
    retry: (failureCount, error) => {
      if (error?.status === 401 || error?.status === 403) {
        return false;
      }
      return failureCount < 3;
    }
  });

  const login = (returnUrl = null) => {
    if (typeof returnUrl === 'string') {
      logIn(returnUrl);
    } else {
      logIn();
    }
  };

  const logout = () => {
    localStorage.removeItem('authToken');
    queryClient.setQueryData(['user'], null);
    logOut();
  };

  const isAuthenticated = !!user && !error;

  return {
    user: user || null,
    isLoading,
    isAuthenticated,
    login,
    logout,
    error
  };
};